/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L6_Feat2_BodyInputs */

const es_l6_feat2_body = /** @type {(inputs: L6_Feat2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendario, reservas y cobros gestionados desde un único panel.`)
};

const gl_l6_feat2_body = /** @type {(inputs: L6_Feat2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendario, reservas e cobros xestionados dende un único panel.`)
};

const en_l6_feat2_body = /** @type {(inputs: L6_Feat2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendar, bookings and payments managed from a single dashboard.`)
};

/**
* | output |
* | --- |
* | "Calendar, bookings and payments managed from a single dashboard." |
*
* @param {L6_Feat2_BodyInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l6_feat2_body = /** @type {((inputs?: L6_Feat2_BodyInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L6_Feat2_BodyInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l6_feat2_body(inputs)
	if (locale === "en") return en_l6_feat2_body(inputs)
	return es_l6_feat2_body(inputs)
});